<script>
    import { editorState } from "@app/store/editorStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
    import { commitHistory } from "@app/store/historyStore.svelte.js";
    import { snapSelectedStartsToPrevious } from "@app/lib/snapEvents.js";
    import { toast } from "@zerodevx/svelte-toast";
    import * as m from '@app/paraglide/messages.js';

    let isDisabled = $derived(!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0 || isSelectedEventGroupLocked());

    function snapToStart() {
        try {
            if (isSelectedEventGroupLocked()) {
                toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
                return;
            }

            const egIdx = projectState.selected;
            const eventGroup = eventGroupState[egIdx];
            if (!eventGroup?.selected?.length) {
                return;
            }

            const selected = [...eventGroup.selected];
            const gapSec = editorState.minFrameGap / projectState.frameRate;
            const preview = eventGroup.events.map((event) => ({
                start: event.start,
                end: event.end,
            }));

            if (!snapSelectedStartsToPrevious(preview, selected, gapSec)) {
                return;
            }

            commitHistory({
                name: "snap to start",
                eventGroup: egIdx,
                mutate: {
                    eventGroupState: (draft) => {
                        snapSelectedStartsToPrevious(
                            draft[egIdx].events,
                            selected,
                            gapSec,
                        );
                    },
                },
            });
        } catch (err) {
            console.log(err);
            console.log(err.message);
        }
    }
</script>

<li class="nav-item" title={m.snap_to_start_title()}
    role="none">
    <a class="nav-link" 
       href="#!/"
       role="button"
       id="snap-to-start-btn"
       aria-label={m.snap_to_start_aria_label()}
       class:disabled={isDisabled}
       aria-disabled={isDisabled}
       onclick={snapToStart}>
        <i class="bi bi-align-start" aria-hidden="true"></i>
    </a>
</li>
